export default "__VITE_ASSET__DKuRZ76e__"